// istanbul ignore file

import { cva } from "cva";

export const blockStyle = cva(["relative"], {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "bg-brand-indigo",
      dark: "bg-gray-900",
      light: "bg-white",
    },
  },
});
